import React from 'react';
import AiPlayer from './Ailayer';

const ThreeDCharacter = () => {

    return (
        <div>
            <header className="main_header">
                <div className="left_div">
                    <div className="logo logo_heading">
                        <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal" /></a>
                    </div>
                </div>
            </header>

            <table id="tblContainer" cellSpacing="0" align="center" border="0">
                <tbody>
                    <tr>
                        <td id="tdContent">
                            <p class="feature_entire_heading text-center f-bold h2" style={{ marginBottom: "0px" }} align="center"><b>AI Agent with Speech Input - React JS </b></p>
                            <p class="feature_entire_heading text-center f-bold h3" style={{ marginTop: "10px" }} align="center"><b>Using the AI Agent Wizard - NoCode Solution</b></p>
                            <p className="feature_entire_heading text-center" id="normal-text" align="center">In this example we demonstrate
                                an AI Agent that responds to speech input. <br />Read our <a className="selected_support"
                                    href="/docs/Implementing_Your_AI_Agent.pdf" target="_blank">technical note</a> to learn more.</p>
                            <p className="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
                                yet support the Web Speech API we've automatically replaced speech input with text input.</p>


                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                <tbody>
                                    <tr>
                                        <td align="center" colSpan="2" className="feature_entire_heading text-center sayAi">
                                            {/* <!-- ******************************* SITEPAL EMBED CODE START  ***********************  --> */}
                                            <div style={{ minWidth: "900px", maxHeight: "460px" }}>
                                                <AiPlayer />
                                            </div>
                                            {/* <SitePal embed='16851,360,480,"",1,1, 2695840, 0,1,1,"5c6fde06460aa8ab405bf4f13cf93cf0",0' /> */}
                                            {/* <!-- ******************************* SITEPAL EMBED CODE END  ***********************  --> */}
                                            <br />
                                        </td>
                                    </tr>
                                    <tr align="middle">
                                        <td align="center" colSpan="2" className="feature_entire_heading text-center">
                                            <p>Real-time Artificial Intelligence Engine provides automatic Text and
                                                Audio responses to the questions provided. </p>
                                            <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and
                                                language.</p><br />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <footer>
                <div className="footer-menu oddcast text-center">
                    <ul className="w-50 m-auto ">
                        <li className="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
                        <li>To view the source code of this page, <a href="/api/examples/react-ai-agent-speak/Sitepal-react-agent-ai.zip"
                            download="">download </a>
                            source code</li>
                    </ul>
                </div>
            </footer>
        </div>
    );
};

export default ThreeDCharacter;
